import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #SIDE-MENU
\*------------------------------------ */
/**
 * 1) Menu that acts as a side navigation. This can collapse or expand depending on the use-case
 */
:host {
  display: block;
}

/**
 * Side menu within the web component wrapper
 * 1) Span the list item link background the entire width
 */
.cat-c-side-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  --cat-list-item-link-margin-inline-end: 0; /* 1 */
  --cat-list-item-link-padding-inline-end: var(--cat-space-medium);
  --cat-side-menu-after-top: -2px;
  --cat-side-menu-link-align-items: center;
  --cat-side-menu-item-panel-list-item-body-margin-inline-start: var(--cat-space-x-large);
  --cat-list-item-link-width: calc(100%);
  --cat-list-item-link-hover: var(--cat-theme-color-content-strong);
  --cat-list-item-link-strong-hover: var(--cat-theme-color-content-strong-hover);
  --cat-list-item-background-color: transparent;
  height: 100%;
  width: 100%;
}
.cat-c-side-menu:not(.cat-is-mobile) {
  --cat-side-menu-item-panel-list-item-body-margin-inline-start: var(--cat-space-5x-large);
  --cat-list-item-link-padding-inline-end: calc(var(--size-base-unit) * 2.875);
  border-inline-end: 1px solid var(--cat-theme-color-border-default);
}
.cat-c-side-menu:not(.cat-is-collapsed) {
  --cat-list-item-link-margin-inline-start: 0;
  --cat-list-item-link-padding-inline-start: 0;
}
.cat-c-side-menu.cat-is-mobile {
  --cat-side-menu-link-padding-inline-start: var(--cat-space-x-large);
  position: var(--cat-side-menu-is-mobile-position, absolute);
  z-index: var(--cat-z-index-500);
}

/**
 * Side menu link
 */
.cat-c-side-menu__nav {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  color: var(--cat-theme-color-content-default);
  transition: width var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-side-menu:not(.cat-is-mobile) .cat-c-side-menu__nav {
  padding-inline: 0;
}

/**
 * Collapsed side menu
 * 1) List of custom properties used to pass down into side-menu items so user doesn't need
 * to apply isCollapsed to all items
 */
.cat-c-side-menu.cat-is-collapsed {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
  /**
  * Collapsed side menu
  * will hide the side-menu on collapsed state in mobile view. 
  */
}
.cat-c-side-menu.cat-is-collapsed:not(.cat-is-mobile) {
  width: var(--cat-side-menu-collapse-width, 4.5rem);
  --cat-side-menu-text-white-space: nowrap;
  --cat-side-menu-text-text-overflow: ellipsis;
  --cat-side-menu-text-overflow: hidden;
  --cat-side-menu-link-flex-direction: column;
  --cat-side-menu-link-text-align: center;
  --cat-side-menu-icon-margin-inline-end: 0;
  --cat-side-menu-icon-margin-block-end: var(--cat-space-3x-small);
  --cat-side-menu-after-position: absolute;
  --cat-side-menu-after-top: -1px;
  --cat-side-menu-after-right: var(--cat-space-3x-small);
  --cat-side-menu-items-icon-display: none;
  --cat-side-menu-item-panel-position: absolute;
  --cat-side-menu-item-panel-background: var(--cat-theme-color-background-default);
  --cat-side-menu-item-panel-box-shadow: var(--cat-theme-box-shadow-md);
  --cat-side-menu-item-panel-border-radius: var(--cat-theme-border-radius);
  --cat-list-item-link-width: calc(100% - calc(var(--size-base-unit) * 0.5)); /* 2 */
  --cat-list-item-link-margin-inline-end: unset; /* 2 */
  --cat-side-menu-link-padding-block-start: calc(var(--size-base-unit) * 1.125);
  --cat-side-menu-link-padding-inline-end: calc(var(--size-base-unit) * 1.25);
  --cat-side-menu-link-padding-block-end: calc(var(--size-base-unit) * 1.125);
  --cat-side-menu-link-padding-inline-start: calc(var(--size-base-unit) * 1.25);
  --cat-side-menu-slotted-side-menu-link-padding-inline-start: var(--cat-space-medium);
  --cat-side-menu-slotted-list-min-width: 15rem;
  --cat-side-menu-item-margin-block-end: var(--cat-space-x-small);
  --cat-side-menu-item-panel-list-item-body-margin-inline-start: 0;
  --cat-side-menu-item-panel-height: 70vh;
}
.cat-c-side-menu.cat-is-collapsed .cat-c-side-menu__nav {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
}
.cat-c-side-menu.cat-is-collapsed:not(.cat-is-mobile) {
  --cat-list-item-link-padding-inline-end: calc(var(--size-base-unit) * 1.25);
}
.cat-c-side-menu.cat-is-collapsed.cat-is-mobile {
  display: var(--cat-side-menu-display, none);
}

.cat-c-side-menu.cat-is-mobile {
  --cat-list-item-link-hover-background: var(--cat-theme-color-content-strong-hover);
}

/**
  * height for sidemenu nav 
  **/
.cat-c-side-menu:not(.cat-is-collapsed) .cat-c-side-menu__nav {
  overflow-y: auto;
}
.cat-c-side-menu.cat-is-mobile .cat-c-side-menu__nav {
  background-color: var(--cat-theme-color-content-strong);
  min-height: 100%;
  max-height: 100%;
}

/**
 * Side menu list
 */
.cat-c-side-menu__list {
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: visible;
}

/**
 * Side menu footer
 * 1) Slot for footer content to go into like legal text
 */
.cat-c-side-menu__footer {
  padding: var(--cat-space-medium);
  border-block-start: var(--cat-border-width-sm) solid var(--cat-theme-color-border-default);
}

/**
 * Side menu header
 * 1) Slot for header content
 */
.cat-c-side-menu__header {
  margin-block-end: var(--cat-space-medium);
  padding: var(--cat-space-medium);
  border-block-end: var(--cat-border-width-sm) solid var(--cat-theme-color-border-subtle);
}

.cat-c-side-menu:not(.cat-c-side-menu--has-header-slot) .cat-c-side-menu__header, .cat-c-side-menu:not(.cat-c-side-menu--has-footer-slot) .cat-c-side-menu__footer {
  display: none;
}
`;
       